import { render, staticRenderFns } from "./login-page.vue?vue&type=template&id=c925a366&scoped=true"
import script from "./login-page.vue?vue&type=script&lang=js"
export * from "./login-page.vue?vue&type=script&lang=js"
import style0 from "./login-page.vue?vue&type=style&index=0&id=c925a366&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c925a366",
  null
  
)

export default component.exports